import Category from '@/models/Category';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import Constants from '../../Constants';
import http from '../../services/HttpService';
import { updatePersonOnboarded } from '../identity/action';
import { completeOnboardFailure, completeOnboardSuccess } from './actions';
import { OnboardTypes } from './types';

export function* completeOnboardRequest(action: PayloadAction<OnboardTypes.COMPLETE_ONBOARD_REQUEST, Category[]>) {
    try {
        yield call(http.post, Constants.CAST_PERSONS_ONBOARD_URI, action.payload);
        yield put(completeOnboardSuccess());
        yield put(updatePersonOnboarded(true));
    } catch (error) {
        yield put(completeOnboardFailure());
    }
}
